export default "__VITE_ASSET__a4456ac8__"